<template>
  <form @submit.prevent="handleSubmit">
    <label>{{ $t('noahfit.modal.height_label') }}</label>
    <input v-model.number="form.height" type="number" required />

    <label>{{ $t('noahfit.modal.weight_label') }}</label>
    <input v-model.number="form.weight" type="number" required />

    <label>{{ $t('noahfit.modal.age_label') }}</label>
    <input v-model.number="form.age" type="number" required />

    <label>{{ $t('noahfit.modal.sex_label') }}</label>
    <select v-model="form.sex" required>
      <option value="male">{{ $t('noahfit.modal.sex_male') }}</option>
      <option value="female">{{ $t('noahfit.modal.sex_female') }}</option>
    </select>

    <label>{{ $t('noahfit.modal.activity_label') }}</label>
    <select v-model.number="form.activity" required>
      <option v-for="(opt, idx) in $tm('noahfit.modal.activity_options')" :key="idx" :value="idx + 1">{{ opt }}</option>
    </select>

    <button type="submit">{{ $t('noahfit.modal.calculate') }}</button>
  </form>
</template>

<script>
export default {
  name: 'ModalForm',
  props: {
    initialForm: {
      type: Object,
      default: () => ({
        height: null,
        weight: null,
        age: null,
        sex: 'male',
        activity: 5,
      }),
    }
  },
  data() {
    return {
      form: { ...this.initialForm }
    };
  },
  emits: ['submit'],
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form });
    }
  }
};
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
}
label {
  margin-top: 10px;
}
input, select {
  padding: 6px;
  margin-top: 4px;
}
button {
  margin-top: 16px;
  padding: 8px 16px;
}
</style>
